// extracted by mini-css-extract-plugin
export default {"actionButton":"FormSchema_actionButton__+A+Yy","fileContainer":"FormSchema_fileContainer__quFyc","buttonWrapper":"FormSchema_buttonWrapper__J5uoX"};